<template>
  <div class="number-picker">
    <div
      class="left"
      @touchend="handleSub"
    >
      <a-icon
        type="minus"
        style="color: #1890FF;"
      />
    </div>
    <div class="center">
      <input
        v-if="editable"
        type="number"
        :value="value"
        @change="handleChange($event)"
      >
      <span v-else>{{ value }}</span>
    </div>
    <div
      class="right"
      @touchend="handleAdd"
    >
      <a-icon
        type="plus"
        style="color: #1890FF;"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'NumberPicker',
  props: {
    value: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    },
    minValue: {
      type: Number,
      default: 0
    },
    maxValue: {
      type: Number,
      default: 99999
    },
    condition: {
      type: Function,
      default: undefined
    },
    editable: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    handleChange (e) {
      if (this.disabled) return

      const value = 1.0 * e.target.value

      let result = true
      if (typeof this.condition === 'function') {
        if (this.value > value) {
          result = this.condition('sub', value - this.value)
        }
        if (this.value < value) {
          result = this.condition('add', value - this.value)
        }
      }

      if (result && this.minValue < value && value < this.maxValue) {
        this.$emit('input', value)
        this.$emit('change', value)
      } else {
        e.target.value = this.value
      }
    },
    handleAdd () {
      if (this.disabled) return

      let result = true
      if (typeof this.condition === 'function') {
        result = this.condition('add', 1)
      }
      if (this.value < this.maxValue && result) {
        const value = 1.0 * this.value + 1
        this.$emit('input', value)
        this.$emit('change', value)
      }
    },
    handleSub () {
      if (this.disabled) return

      let result = true
      if (typeof this.condition === 'function') {
        result = this.condition('sub', -1)
      }
      if (this.value > this.minValue && result) {
        const value = 1.0 * this.value - 1
        this.$emit('input', value)
        this.$emit('change', value)
      }
    }
  }
}
</script>

<style scoped>
  .number-picker .left {
    display: inline-block;
    border: 1px solid rgb(220, 220, 220);
    border-radius: 5px 0px 0px 5px;
    width: 40px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    cursor: pointer;
  }

  .number-picker .right {
    display: inline-block;
    border: 1px solid rgb(220, 220, 220);
    border-radius: 0px 5px 5px 0px;
    width: 40px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    cursor: pointer;
  }

  .number-picker .center {
    display: inline-block;
    border: 1px solid rgb(220, 220, 220);
    border-left: 0px;
    border-right: 0px;
    width: 45px;
    height: 28px;
    line-height: 28px;
    text-align: center;
  }

  .number-picker input {
    color: rgba(0, 0, 0, 0.65);
    border: 0px;
    width: 45px;
    height: 22px;
    line-height: 22px;
    text-align: center;
    background: white;
  }
</style>
